// Libraries.
import { ReactNode } from 'react';
import ReactTooltip from 'react-tooltip';

// Assets.
import IconInfo from '../../assets/icons/info-icon.svg';
import AlertIcon from '../../assets/icons/warning-icon.svg';
import CheckIcon from '../../assets/icons/check-icon.svg';

interface TooltipProps {
  id: string;
  children: ReactNode;
  message: string;
  multiline?: boolean;
  type?: string;
  position?: string;
  html?: string;
  icon?: boolean;
  iconImage?: boolean;
  checkIcon?: boolean;
  className?: string;
}

export const Tooltip = ({
  id,
  children,
  message,
  multiline = false,
  type = 'dark',
  position = '',
  html = '',
  icon = false,
  iconImage = false,
  checkIcon = false,
  className,
}: TooltipProps) => {
  let iconElement = null;

  if (icon) {
    iconElement = <IconInfo width={16} height={16} />;
  } else if (iconImage) {
    iconElement = <AlertIcon width={16} height={16} />;
  } else if (checkIcon) {
    iconElement = <CheckIcon width={18} height={18} />;
  }

  return (
    <>
      <ReactTooltip id={id} />
      <div
        data-for={id}
        data-tip={html ? '' : message}
        data-type={type}
        data-multiline={multiline}
        data-place={position}
        data-html={html}
        className={className}
      >
        {iconElement}
        {children}
      </div>
    </>
  );
};
